// export const BASE_URL = (typeof process === 'object') ? process.env.PUBLIC_URL : "http://localhost:3001";
// export const BASE_URL = (typeof process === 'object') ? process.env.PUBLIC_URL : "http://192.168.63.179:3001";
export const BASE_URL = (typeof process === 'object') ? process.env.PUBLIC_URL : "https://joglekarkul.com";
